import isInstance from './isInstance.js';

const isArray = (x) => isInstance(Array, x);
export default isArray;
